import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const LifestyleCard = ({ habit }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-all">
      {/* Header - Always Visible */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-6 flex items-center justify-between text-left hover:bg-slate-50 transition-colors rounded-xl"
      >
        <div className="flex-1">
          <h3 className="text-xl font-semibold text-slate-900 mb-1">
            {habit.name}
          </h3>
          <span className="inline-block px-3 py-1 bg-teal-50 text-teal-700 text-sm font-medium rounded-full">
            {habit.category}
          </span>
        </div>
        <div className="ml-4">
          {isExpanded ? (
            <ChevronUp className="h-6 w-6 text-slate-400" />
          ) : (
            <ChevronDown className="h-6 w-6 text-slate-400" />
          )}
        </div>
      </button>

      {/* Expanded Content */}
      {isExpanded && (
        <div className="px-6 pb-6 space-y-6 border-t border-slate-100 pt-6">
          {/* Why People Explore This */}
          <div>
            <h4 className="text-sm font-semibold text-slate-900 uppercase tracking-wide mb-3">
              Why People Explore This
            </h4>
            <p className="text-slate-700 leading-relaxed">
              {habit.whyPeopleExplore}
            </p>
          </div>

          {/* Common Approaches */}
          <div>
            <h4 className="text-sm font-semibold text-slate-900 uppercase tracking-wide mb-3">
              Common Approaches
            </h4>
            <ul className="space-y-2">
              {habit.commonApproaches.map((approach, index) => (
                <li key={index} className="flex items-start">
                  <span className="inline-block w-1.5 h-1.5 bg-teal-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span className="text-slate-700 leading-relaxed">{approach}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* General Notes */}
          <div className="bg-slate-50 border border-slate-200 rounded-lg p-4">
            <h4 className="text-sm font-semibold text-slate-900 uppercase tracking-wide mb-3">
              General Notes
            </h4>
            <p className="text-sm text-slate-700 leading-relaxed">
              {habit.generalNotes}
            </p>
          </div>

          {/* Disclaimer */}
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <p className="text-xs text-slate-700 leading-relaxed">
              This information is provided for general educational purposes only and does not constitute medical advice.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LifestyleCard;
